/* Wall Arts Design: keep the desktop mega menu panel height in sync with its real content.
   The theme measures a dropdown the instant it opens, which on the first hover can be before
   the dropdown has been drawn. This watches each dropdown and corrects the height as soon as
   the real size is known, so the panel opens once at the right size. */
(function () {
  if (!('ResizeObserver' in window)) return;
  var desktop = window.matchMedia('(min-width: 750px)');
  var observed = new WeakSet();

  function isOpen(submenu) {
    var item = submenu.closest('.menu-list__list-item');
    if (!item || item.getAttribute('slot') === 'overflow') return false;
    var link = item.querySelector('[ref="menuitem"]');
    return !!link && link.getAttribute('aria-expanded') === 'true';
  }

  function sync(submenu) {
    if (!desktop.matches || !isOpen(submenu)) return;
    var header = submenu.closest('header-component');
    var height = submenu.offsetHeight;
    if (!header || !height) return;
    var current = parseFloat(header.style.getPropertyValue('--submenu-height')) || 0;
    if (Math.abs(current - height) < 1) return;
    var overlap = header.hasAttribute('data-submenu-overlap-bottom-row');
    var topRow = overlap ? header.querySelector('.header__row--top') : null;
    var visible = topRow ? topRow.offsetHeight : header.offsetHeight;
    header.style.setProperty('--submenu-height', height + 'px');
    header.style.setProperty('--full-open-header-height', height + visible + 'px');
  }

  var observer = new ResizeObserver(function (entries) {
    entries.forEach(function (entry) { sync(entry.target); });
  });

  function watch() {
    document.querySelectorAll('header-menu .menu-list__submenu').forEach(function (submenu) {
      if (observed.has(submenu)) return;
      observed.add(submenu);
      observer.observe(submenu);
    });
  }

  // Open a dropdown that is being hovered but did not open, which happens when the
  // pointer arrives before the theme's menu script is ready or while the header is being re-rendered.
  function openIfMissed(item) {
    if (!item || !item.isConnected || item.getAttribute('slot') || !item.matches(':hover')) return;
    var link = item.querySelector('[ref="menuitem"]');
    if (!link || !link.hasAttribute('aria-haspopup') || link.getAttribute('aria-expanded') === 'true') return;
    var menu = item.closest('header-menu');
    if (menu && typeof menu.activate === 'function') menu.activate({ target: item });
  }

  function hoveredItem() {
    return document.querySelector('header-menu .menu-list__list-item:not([slot]):hover');
  }

  // The header is re-rendered after load, so pick up new dropdown elements on hover too.
  document.addEventListener('pointerover', function (event) {
    var target = event.target;
    if (!(target instanceof Element)) return;
    var item = target.closest('header-menu .menu-list__list-item');
    if (!item) return;
    watch();
    var submenu = item.querySelector('.menu-list__submenu');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        openIfMissed(item);
        if (submenu) sync(submenu);
      });
    });
  }, { passive: true });

  // When the menu script becomes ready, open whatever the visitor is already hovering.
  if (window.customElements) {
    customElements.whenDefined('header-menu').then(function () {
      requestAnimationFrame(function () { openIfMissed(hoveredItem()); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();
